import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Pair with useConfirmedNavigate():
 *
 *   const { navigateSafely, isPromptOpen, confirmLeave, cancelLeave } = useConfirmedNavigate();
 *   <ConfirmLeaveModal open={isPromptOpen} onStay={cancelLeave} onLeave={confirmLeave} />
 */
export default function ConfirmLeaveModal({
  open,
  onStay,
  onLeave,
  title = "Leave CC Onboarding?",
  message = "You have unsaved changes on this step. If you leave now, they will be lost.",
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 px-4">
      <div className="w-full max-w-sm rounded-2xl bg-white p-6 shadow-xl ring-1 ring-slate-100">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100">
            <AlertTriangle className="h-5 w-5 text-amber-600" />
          </div>
          <div>
            <h3 className="text-sm font-bold text-slate-900">{title}</h3>
            <p className="mt-1 text-sm text-slate-500">{message}</p>
          </div>
        </div>
        <div className="mt-6 flex justify-end gap-2">
          <button
            type="button"
            onClick={onStay}
            className="rounded-lg border border-slate-200 px-4 py-2 text-sm font-medium text-slate-600 transition hover:bg-slate-50"
          >
            Stay on this page
          </button>
          <button
            type="button"
            onClick={onLeave}
            className="rounded-lg bg-rose-600 px-4 py-2 text-sm font-semibold text-white transition hover:bg-rose-700"
          >
            Leave without saving
          </button>
        </div>
      </div>
    </div>
  );
}
